module.exports = __webpack_public_path__ + "img/mgh-nagoya.cfb07a1e.jpg";